import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import CartButton from '../store/CartButton';
import { useGlobal } from '../../contexts/GlobalContext';
import { auth } from '../../firebaseConfig';
import { Utils } from '../../common/Utils';
import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';

function NavBar() {
  const { user, isAdmin, logOut, settings, cart } = useGlobal();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logOut();
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleLogin = async () => {

    if (settings.allowMicrosoftLogin) {
      const provider = new OAuthProvider("microsoft.com");

      try {
        await signInWithPopup(auth, provider);
        console.log("Microsoft login successful");
      } catch (err: any) {
        alert("Login Error");
        console.error("Microsoft Login Error:", err);
      }
    }
    else if (settings.allowGoogleLogin) {
      const provider = new GoogleAuthProvider();
      try {
        await signInWithPopup(auth, provider);
        console.log("Google login successful");
      } catch (err: any) {
        alert("Login Error")
        console.error("Google Login Error:", err);
      }
    }

  };

  const singleLogin = settings && !settings.allowEmailLogin && ((settings.allowGoogleLogin && !settings.allowMicrosoftLogin) || (!settings.allowGoogleLogin && settings.allowMicrosoftLogin));

  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href={Utils.GetUrl("/")}>{settings && settings.siteLogo ? <img src={settings.siteLogo} alt={settings.siteTitle} className='site-logo' /> : settings ? settings.siteTitle : "OrderQ"}</Navbar.Brand>

        {/* Cart icon visible only on mobile */}
        <div className="d-lg-none ms-auto d-flex align-items-center gap-3">
          <div className="position-relative">
          <ShoppingCart size={25}
          style={{ cursor: "pointer"}}
          onClick={() => navigate(Utils.GetUrl("/cart"))}
          ></ShoppingCart>
          {cart && cart.cartItems && cart.cartItems.length > 0 && (
            <span className="position-absolute top-0 start-100 translate-middle badge bg-danger">
              {cart.cartItems.reduce((total, item) => total + item.quantity, 0)}
            </span>
          )}
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
        </div>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto d-lg-flex gap-lg-4">
            <Nav.Link href={Utils.GetUrl("/products")}>Products</Nav.Link>
            {user && <Nav.Link href={Utils.GetUrl("/orders")}>My Orders</Nav.Link>}
            {user && isAdmin && <NavDropdown title="Admin" id="basic-nav-dropdown">
              <NavDropdown.Item href={Utils.GetUrl("/admin/categories")}>Category List</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/products")}>
                Product List
              </NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/orders")}>Orders</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/settings")}>Settings</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/storeoperator")}>Register Store Operator</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/labelgenerator")}>Delivery Location Generator</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/earningsanalytics")}>Earnings Analytics</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/siteanalytics")}>Site Analytics</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/instructions")}>Setup Instructions</NavDropdown.Item>
              <NavDropdown.Item href={Utils.GetUrl("/admin/paymentproviders")}>Payment Options</NavDropdown.Item>
              {/* <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item> */}
            </NavDropdown>}
          {/* </Nav>
          <Nav className="ms-auto"> */}
            {user ? (
              <NavDropdown
                title="User"
                align="end"
              >
                <NavDropdown.Item href={Utils.GetUrl("/feedback")}>Submit Feedback</NavDropdown.Item>
                <NavDropdown.Item href={Utils.GetUrl("/UserProfile")}>User Profile</NavDropdown.Item>
                <NavDropdown.Item onClick={handleLogout}>Log Out</NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Nav.Link
                href={singleLogin ? "#" : Utils.GetUrl("/login")}
                className="ms-2"
                onClick={(e) => {
                  if (singleLogin) {
                    e.preventDefault(); // Prevent navigation if Google login is allowed
                    handleLogin(); // Fire the login event
                  }
                }}
              >
                Sign In
              </Nav.Link>

            )}
            <CartButton />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;